export const getLikiee = /* GraphQL */ `
  query GetLikiee($id: ID!) {
    getLikiee(id: $id) {
      id
      availability
      isEnhancingInProgress
      isVisualMatchesInProgress
      item {
        features
        id
        url
        title
        description
        size
        sku
        upc
        gtin
        color
        brand
        model
        itemSourceId
        canonicalUrl
        additionalProperty
        aggregateRating
        descriptionHtml
        breadcrumbs
        mainImage
        probability
        updatedAt
      }
      source {
        url
        name
        faviconURL
      }
      projects {
        items {
          id
          name
          icon
          visibility
          visibilityGroup
          itemsCount
          createdAt
          updatedAt
        }
      }
      thumbnailURLs
      images
      status
      url
      affiliateURL
      imageURL
      price
      originalPrice
      priceTrend
      currency
      priceRange {
        min
        max
        currency
        count
      }
      breadcrumbs
      description
      name
      createdAt
      features
      priceAlert {
        alertWhenGetsCheaper
        likieeId
        originalPrice
        alertPriceMin
        checkInterval
        id
      }
      aiSummary {
        categoryInsights
        confidenceScore
        dataCompleteness
        generatedAt
        highlights
        imageType
        keyFeatures
        modelVersion
        primaryCategory
        searchableAttributes {
          ageGroup
          allergens
          availableColors
          availableSizes
          certifications
          compatibility
          ecoLabels
          ingredients
          materials
          restrictions
          skillLevel
          warnings
        }
        targetAudience
        useCases
      }
      visualMatches {
        matches {
          link
          source
          thumbnail
          title
          source_icon
          position
          original_url
          price {
            currency
            extracted_value
            value
          }
        }
        locale
        country
        searchType
        searchImage
        searchTerm
        searchCategory
      }
      historicalPrices {
        availability
        currency
        currencyRaw
        date
        price
        regularPrice
      }
      priceAlertId
      updatedAt
      aiSummary {
        generatedAt
        modelVersion
        primaryCategory
        highlights
        keyFeatures
        targetAudience
        useCases
        searchableAttributes {
          allergens
          ingredients
          materials
          certifications
          ecoLabels
          compatibility
          ageGroup
          skillLevel
          warnings
          restrictions
          availableSizes
          availableColors
        }
        categoryInsights
        confidenceScore
        dataCompleteness
      }
      aiEnhancement {
        imageUrl
        processingTime
      }
      reviewsAggregation {
        lastUpdated
        totalReviews
        reviewSources
        averageRating
        ratingDistribution {
          fiveStar
          fourStar
          threeStar
          twoStar
          oneStar
        }
        summary {
          topPositives
          topNegatives
          frequentMentions
          commonUseCases
        }
        sentimentScore {
          positive
          neutral
          negative
        }
        trendingTopics {
          topic
          sentiment
          mentionCount
        }
        detailedInsights
      }
    }
  }
`;

export const searchLikieesQuery = /* GraphQL */ `
  query searchLikiees(
    $aggregates: [SearchableLikieeAggregationInput]
    $filter: SearchableLikieeFilterInput
    $from: Int
    $limit: Int
    $nextToken: String
    $sort: [SearchableLikieeSortInput]
  ) {
    searchLikiees(
      filter: $filter
      aggregates: $aggregates
      from: $from
      limit: $limit
      from: $from
      nextToken: $nextToken
      sort: $sort
    ) {
      items {
        projects {
          items {
            id
          }
        }
        currency
        name
        model
        owner
        price
        originalPrice
        priceTrend
        priceRange {
          min
          max
          currency
          count
        }
        probability
        status
        url
        description
        color
        canonicalUrl
        brand
        availability
        id
        imageURL
        images
        likieeItemId
        likieeSourceId
        mpn
        gtin
        features
        currencyRaw
        categoryTags
        createdAt
        breadcrumbs
        aggregateRating
        additionalProperty
        priceAlertId
        regularPrice
        size
        sku
        sortHash
        style
        supportedLocales
        thumbnailURLs
        upc
        updatedAt
        item {
          mainImage
        }
      }
      total
      nextToken
    }
  }
`;

export const searchLikieesInQuery = /* GraphQL */ `
  query searchLikieesIn(
    $aggregates: [SearchableLikieeAggregationInput]
    $filter: SearchableLikieeFilterInput
    $from: Int
    $limit: Int
    $nextToken: String
    $sort: [SearchableLikieeSortInput]
    $projects: [ID!]
  ) {
    searchLikieesIn(
      filter: $filter
      aggregates: $aggregates
      from: $from
      limit: $limit
      from: $from
      nextToken: $nextToken
      sort: $sort
      projects: $projects
    ) {
      items {
        projects {
          items {
            id
          }
        }
        currency
        name
        model
        owner
        price
        originalPrice
        priceTrend
        priceRange {
          min
          max
          currency
          count
        }
        probability
        status
        url
        description
        color
        canonicalUrl
        brand
        availability
        id
        imageURL
        images
        likieeItemId
        likieeSourceId
        mpn
        gtin
        features
        currencyRaw
        categoryTags
        createdAt
        breadcrumbs
        aggregateRating
        additionalProperty
        priceAlertId
        regularPrice
        size
        sku
        sortHash
        style
        supportedLocales
        thumbnailURLs
        upc
        updatedAt
        item {
          mainImage
        }
      }
      total
      nextToken
    }
  }
`;

export const getLikieesFiltersQuery = /* GraphQL */ `
  query searchLikiees(
    $aggregates: [SearchableLikieeAggregationInput]
    $filter: SearchableLikieeFilterInput
    $from: Int
    $limit: Int
    $nextToken: String
    $sort: [SearchableLikieeSortInput]
  ) {
    searchLikiees(
      filter: $filter
      aggregates: $aggregates
      from: $from
      limit: $limit
      from: $from
      nextToken: $nextToken
      sort: $sort
    ) {
      aggregateItems {
        result {
          ... on SearchableAggregateScalarResult {
            __typename
            value
          }
          ... on SearchableAggregateBucketResult {
            __typename
            buckets {
              doc_count
              key
            }
          }
        }
        name
      }
    }
  }
`;

export const getLikieesInFiltersQuery = /* GraphQL */ `
  query searchLikieesIn(
    $aggregates: [SearchableLikieeAggregationInput]
    $filter: SearchableLikieeFilterInput
    $from: Int
    $limit: Int
    $nextToken: String
    $sort: [SearchableLikieeSortInput]
    $projects: [ID!]
  ) {
    searchLikieesIn(
      filter: $filter
      aggregates: $aggregates
      from: $from
      limit: $limit
      from: $from
      nextToken: $nextToken
      sort: $sort
      projects: $projects
    ) {
      aggregateItems {
        name
        result {
          buckets {
            doc_count
            key
          }
          value
        }
      }
    }
  }
`;

export const getLikieesTotal = /* GraphQL */ `
  query searchLikiees($filter: SearchableLikieeFilterInput) {
    searchLikiees(filter: $filter) {
      total
    }
  }
`;

export const likieeByURL = /* GraphQL */ `
  query likieeByURL($url: AWSURL!) {
    likieeByURL(url: $url) {
      items {
        id
        name
      }
    }
  }
`;

export const getUserProjectLikiee = /* GraphQL */ `
  query getUserProjectLikiee($likieeId: String!, $projectId: String!) {
    getUserProjectLikiee(likieeId: $likieeId, projectId: $projectId) {
      currency
      name
      model
      price
      originalPrice
      priceRange {
        min
        max
        currency
        count
      }
      probability
      status
      url
      affiliateURL
      description
      color
      canonicalUrl
      brand
      availability
      id
      imageURL
      images
      likieeItemId
      likieeSourceId
      mpn
      gtin
      features
      currencyRaw
      categoryTags
      createdAt
      breadcrumbs
      aggregateRating
      additionalProperty
      priceAlertId
      regularPrice
      size
      sku
      sortHash
      style
      supportedLocales
      thumbnailURLs
      upc
      updatedAt
    }
  }
`;
